import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganizationEntityDto } from 'app/@types/dto/organization-entity-dto.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { revealFormErrors } from 'app/main/helpers/form-validation';

@Component({
    selector: 'app-select-measure',
    templateUrl: './select-measure.component.html',
    styleUrls: ['./select-measure.component.scss'],
    standalone: false,
})
export class SelectMeasureComponent implements OnInit {
    // @ts-expect-error: TODO: Remove ignore when types are fixed
    form: FormGroup;
    public availableYears: number[] = [];
    public entities: OrganizationEntityDto[] = [];

    constructor(
        private fb: FormBuilder,
        private ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private readonly host: ElementRef<HTMLElement>,
    ) {}

    ngOnInit(): void {
        const data = this.config.data as {
            questionnaire: { refYear: number };
            activeEntity: OrganizationEntityDto;
            availableYears: number[];
            entities: OrganizationEntityDto[];
        };
        this.form = this.fb.group({
            year: [data.questionnaire.refYear, Validators.required],
            entity: [data.activeEntity, Validators.required],
        });
        this.availableYears = [...data.availableYears];
        this.availableYears.sort();
        this.entities = [...data.entities];
    }

    save(): void {
        if (!revealFormErrors(this.form, this.host.nativeElement)) {
            return;
        }
        this.ref.close(this.form.value);
    }

    close(): void {
        this.ref.close({ year: undefined });
    }
}
